/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import "react-calendar/dist/Calendar.css";

///Images

//Import
import { ThemeContext } from "../../../context/ThemeContext";
import Coverage from "../table/FilteringTable/Coverage";
import { useDispatch, useSelector } from "react-redux";
import { fetchvendorData } from "../../../store/reducers/vendors";

const Home = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchvendorData());
  }, []);
  const { vendorCount, data, loading } = useSelector((state) => state?.vendor);
  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

  return (
    <>
      {loading ? (
        <div className="loader" />
      ) : (
        <>
          <div className="row">
            <div className="col-xl-4 col-sm-4">
              <div className="card gradient-4 card-bx">
                <div className="card-body d-flex align-items-center">
                  <div className="me-auto text-white">
                    <h2 className="text-white">{vendorCount}</h2>
                    <span className="fs-18">Vendors</span>
                  </div>
                  <img src="/img/group.png" width={"45%"} alt="" />
                </div>
              </div>
            </div>
          </div>
          <Coverage data={data} />
        </>
      )}
      {/* <div className="row">
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-1 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{companyCount}</h2>
                <span className="fs-18">Companies</span>
              </div>
              <img src="/img/office.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-2 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{moduleCount}</h2>
                <span className="fs-18">Modules</span>
              </div>
              <img src="/img/employee.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-4">
          <div className="card gradient-3 card-bx">
            <div className="card-body d-flex align-items-center">
              <div className="me-auto text-white">
                <h2 className="text-white">{submoduleCount}</h2>
                <span className="fs-18">Sub-Modules</span>
              </div>
              <img src="/img/driver.png" width={"45%"} alt="" />
            </div>
          </div>
        </div>
      </div>
      <User /> */}
    </>
  );
};
export default Home;
